import { AxiosPromise } from 'axios';
import { instance } from '.';
import { URLS } from './index';
import { Logger } from 'fsts';
import { SearchParams } from '../model/searchParams';
import { DefaultBackendHelper } from '../utils/backendHelper';
import attendeeCourse, { AttendeeCourse, Value } from '../model/attendeeCourse';
import ODataFilterBuilder from 'odata-filter-builder';
import { CONST } from '@/shared/utils/constants';
import DateUtils from '../utils/dateUtils';

const logger = new Logger('backend.AttendeeCourse');
export interface BackendAttendeeCourse {
  getAttendeeCourse(id: string): AxiosPromise<AttendeeCourse>;
  getAttendeeCourses: (
    searchParams: SearchParams,
    attendeeId?: string,
    dateTimeId?: string,
    cancelled?: boolean
  ) => AxiosPromise<Value>;
  deleteAttendeeCourse(id: string): AxiosPromise;
  updateAttendeeCourse(AttendeeCourse: AttendeeCourse): AxiosPromise<any>;
  updateAttendeeCourseMultiple(
    AttendeeCourse: AttendeeCourse[],
    lang?: string
  ): AxiosPromise<any>;
  downloadPdf(dateTimeId: string, lang: string): AxiosPromise<any>;
}

export const defaultBackendAttendeeCourse: BackendAttendeeCourse = {
  getAttendeeCourse(id: string): AxiosPromise<AttendeeCourse> {
    let url = `${URLS.attendeeCourseOdata}/${id}`;
    return instance.get<AttendeeCourse>(url);
  },
  getAttendeeCourses(
    searchParams: SearchParams,
    attendeeId?: string,
    dateTimeId?: string,
    cancelled?: boolean
  ): AxiosPromise<Value> {
    var odfb = ODataFilterBuilder('and');

    if (attendeeId != undefined) {
      odfb.eq(CONST.AttendeeId, attendeeId, false);
    }

    if (dateTimeId != undefined) {
      odfb.eq(CONST.DateTimeId, dateTimeId, false);
    }

    if (cancelled != undefined) {
      odfb.eq('Cancelled', cancelled);
    }

    let url = DefaultBackendHelper.makeUrl(
      `${URLS.attendeeCourseOdata}`,
      searchParams.dataOption,
      searchParams.orClauseFieldsIds,
      searchParams.filter,
      odfb
    );
    logger.log(`getAttendeeCourses${url}`);
    return instance.get<Value>(url);
  },
  deleteAttendeeCourse(id: string): AxiosPromise {
    logger.debug('deleteAttendeeCourse');
    return instance.delete(`${URLS.attendeeCourse}/${id}`);
  },
  updateAttendeeCourse(AttendeeCourse: AttendeeCourse): AxiosPromise<any> {
    logger.debug('updateAttendeeCourse');
    let attendeeCourseToApi = attendeeCourse.toAPI(AttendeeCourse);
    attendeeCourseToApi.ClientLocalDateTime =
      DateUtils.getCurrentLocalDateAsIsoString();

    if (AttendeeCourse.id != undefined) {
      return instance.put<AttendeeCourse>(
        `${URLS.attendeeCourse}`,
        attendeeCourseToApi
      );
    } else {
      return instance.post<AttendeeCourse>(
        `${URLS.attendeeCourse}`,
        attendeeCourseToApi
      );
    }
  },
  updateAttendeeCourseMultiple(
    AttendeeCourse: AttendeeCourse[],
    lang?: string
  ): AxiosPromise<any> {
    let url = `${URLS.attendeeCourse}/AddMultiple`;
    if (lang != undefined)
      url += lang == 'de' ? '?culture=de-DE' : '?culture=en-US';
    return instance.post<AttendeeCourse>(url, {
      AttendeeCourses: attendeeCourse.arrayToAPI(AttendeeCourse),
      ClientLocalDateTime: DateUtils.getCurrentLocalDateAsIsoString(),
    });
  },
  downloadPdf(dateTimeId: string, lang: string): AxiosPromise<any> {
    return instance.get(
      `${URLS.attendeeCourse}/CreatePrintPdf/${dateTimeId}?lang=${lang}`,
      { responseType: 'blob' }
    );
  },
};
